module.exports = __webpack_public_path__ + "static/media/MOVILIDAD_8.4fe7c7fb.png";